import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import GoogleCallback from './pages/GoogleCallback';
import { LocaleProvider } from './i18n/LocaleContext';
import { AuthProvider } from './auth/AuthContext';
import DevBanner from './components/DevBanner';
import { isEmbedded } from './config/embedded';
import './styles/main.scss';

function App() {
  // Inside the Shopify admin iframe the portal is served from
  // /v3/shopify/app (PUBLIC_URL pins it at build time), and there is only the
  // dashboard — no marketing home, no login — so its pages sit at the root.
  const embedded = isEmbedded();

  return (
    <LocaleProvider>
      <AuthProvider>
        {!embedded && <DevBanner />}
        <Router basename={process.env.PUBLIC_URL || '/'}>
          {embedded ? (
            <Routes>
              {/* Every path is a dashboard page (/products, /stats …); the
                  API serves the shell for all of /v3/shopify/app/*. */}
              <Route path="/*" element={<Dashboard />} />
            </Routes>
          ) : (
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              {/* One route for every page (/dashboard/products …), so switching
                  pages keeps the Dashboard mounted — see Dashboard.js. */}
              <Route path="/dashboard/*" element={<Dashboard />} />
              {/* Google OAuth popup lands here; it relays the token to the login tab. */}
              <Route path="/google-callback" element={<GoogleCallback />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          )}
        </Router>
      </AuthProvider>
    </LocaleProvider>
  );
}

export default App;
